import { Log } from '../../../models';
import { client } from '../../client';
import RequestService from '../requestService';

export  class LoggService extends RequestService<Log, 'logg'>
{
    harVartInnlogget = async (gidId : string) => client.get<boolean>(`${this.serviceName}/harVartInnlogget/${encodeURIComponent(gidId)}`);
}